import Cookies from 'js-cookie'

export function getCookie(name: string) {
	const rawValue = Cookies.get(name)
	if (rawValue) {
		return JSON.parse(rawValue)
	}
}
